import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 400px;
  margin: ${props => props.align === 'center' ? '0 auto' : (props.align === 'right' ? '0 0 0 auto' : '0')};
  background: var(--glass-2);
  padding: 30px;
  border-radius: var(--radius, 16px);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(var(--glass-blur-heavy, 24px));
  box-shadow: 0 16px 40px rgba(0,0,0,0.2);
  text-align: center;
`;

const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 8px;
  color: var(--text-primary);
  font-size: 22px;
`;

const SubText = styled.p`
  color: var(--text-muted);
  font-size: 13px;
  margin-bottom: 24px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid var(--glass-border);
  background: rgba(0,0,0,0.3);
  color: var(--text-primary);
  margin-bottom: 12px;
  outline: none;

  &:focus {
    border-color: var(--accent);
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  color: #fff;
  font-weight: bold;
  border: none;
  cursor: pointer;
  margin-top: 8px;
  box-shadow: 0 4px 15px var(--accent-glow);
`;

const ForgotLink = styled.a`
  display: block;
  margin-top: 15px;
  color: var(--accent);
  font-size: 12px;
  text-decoration: none;
  &:hover { text-decoration: underline; }
`;

const LoginWidget = ({ node }) => {
  const title = node.content?.title || 'Willkommen zurück';
  const subtitle = node.content?.subtitle || 'Bitte loggen Sie sich ein.';
  const btnText = node.content?.btnText || 'Login';

  return (
    <Wrapper align={node.style?.desktop?.align || 'center'} width={node.style?.desktop?.width}>
      <Title>{title}</Title>
      {subtitle && <SubText>{subtitle}</SubText>}
      <form onSubmit={e => e.preventDefault()}>
        <Input type="text" placeholder="E-Mail oder Benutzername" />
        <Input type="password" placeholder="Passwort" />
        <Button className="tef-bubbles">{btnText}</Button>
      </form>
      <ForgotLink href="#">Passwort vergessen?</ForgotLink>
    </Wrapper>
  );
};

registry.register('login_form', {
  label: 'Login Box',
  icon: '🔐',
  category: 'forms',
  defaultContent: {
    title: 'Kunden Login',
    subtitle: 'Verwalte deine Verträge & Daten',
    btnText: 'Anmelden'
  },
  defaultStyle: {
    desktop: { align: 'center', width: '100%' }
  },
  render: LoginWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Texte',
          fields: [
            { name: 'content.title', label: 'Titel', type: 'text' },
            { name: 'content.subtitle', label: 'Untertitel', type: 'text' },
            { name: 'content.btnText', label: 'Button Text', type: 'text' }
          ]
        }
      ]
    }, {
      tab: 'style',
      groups: [
        { title: 'Layout', fields: [ { name: 'style.desktop.align', label: 'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'left'}] } ] }
      ]
    }
  ]
});
